import axios from "axios";

import { IGetPendingBookingsListParams, IPendingBookingsByLocationsList } from "../../pages/dashboard/types";

export const getPendingBookingsByLocations = async (params: IGetPendingBookingsListParams): Promise<IPendingBookingsByLocationsList[]> => {
    const response = await axios.post('/booking/dashboard/byLocations', params);
    return response.data;
};
